import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Autosuggest from 'react-autosuggest'
import TextField from '@material-ui/core/TextField'
import Paper from '@material-ui/core/Paper'
import MenuItem from '@material-ui/core/MenuItem'
import { withStyles } from '@material-ui/core/styles'
import Styles from '../common/styles'

class Autocomplete extends Component {
  constructor (props) {
    super(props)
    this.state = {
      value: props.value || ''
    }
  }

  handleChange = (event, { newValue }) => {
    this.setState({
      value: newValue
    })
  }

  getSuggestionValue = suggestion => {
    let values = this.props.suggestionProperty.split(',')
    let suggestionValue = ''
    values.forEach(v => (suggestionValue += `${suggestion[v]} `))
    return suggestionValue
  }

  renderSuggestionsContainer (options) {
    const { containerProps, children } = options

    return (
      <Paper {...containerProps} square>
        {children}
      </Paper>
    )
  }

  renderSuggestion = (suggestion, { query, isHighlighted }) => {
    if (this.state.value.length < 5) return null
    return (
      <MenuItem
        style={{ borderBottom: '1px solid rgba(0, 0, 0, 0.075)' }}
        className={this.props.classes.suggestion}
        selected={isHighlighted}
        component='div'
      >
        {this.props.renderSuggestion(suggestion, { query, isHighlighted })}
      </MenuItem>
    )
  }

  renderInput (inputProps) {
    const { label, margin, classes, autoFocus, value, ref, shouldUpdate, currentMatch, ...other} = inputProps

    var currentValue = value
    if (shouldUpdate && value) currentValue = currentMatch

    return (
      <TextField
        label={label}
        margin={margin}
        autoFocus={autoFocus}
        value={currentValue}
        inputRef={ref}
        InputProps={{
          disableUnderline: true,
          classes: {
            root: classes.root,
            input: classes.input
          },
          ...other
        }}
        InputLabelProps={{
          shrink: true,
          className: classes.formLabel
        }}
        fullWidth
      />
    )
  }

  render () {
    const {
      classes,
      suggestions,
      onSuggestionsFetchRequested,
      onSuggestionsClearRequested,
      onSuggestionSelected,
      noAbsoluteSuggestionContainer
    } = this.props

    return (
      <Autosuggest
        theme={{
          container: classes.suggestionsContainer,
          suggestionsContainerOpen: noAbsoluteSuggestionContainer
            ? classes.noAbsoluteSuggestionsContainerOpen
            : classes.suggestionsContainerOpen,
          suggestionsList: classes.suggestionsList,
          suggestion: classes.suggestion
        }}
        renderInputComponent={this.renderInput}
        suggestions={suggestions}
        onSuggestionsFetchRequested={onSuggestionsFetchRequested}
        onSuggestionsClearRequested={onSuggestionsClearRequested}
        onSuggestionSelected={onSuggestionSelected}
        renderSuggestionsContainer={this.renderSuggestionsContainer}
        getSuggestionValue={this.getSuggestionValue}
        renderSuggestion={this.renderSuggestion}
        required={this.required}
        inputProps={{
          autoFocus: this.props.autoFocus,
          classes,
          placeholder: this.props.placeholder,
          label: this.props.label,
          margin: this.props.margin,
          value: this.state.value,
          shouldUpdate: this.props.shouldUpdate,
          currentMatch: this.props.value,
          onChange: this.handleChange,
          style: this.props.inputStyles
        }}
      />
    )
  }
}

Autocomplete.propTypes = {
  value: PropTypes.string,
  shouldUpdate: PropTypes.bool,
  placeholder: PropTypes.string,
  label: PropTypes.string,
  margin: PropTypes.string,
  autoFocus: PropTypes.bool,
  onSuggestionsFetchRequested: PropTypes.func.isRequired,
  onSuggestionsClearRequested: PropTypes.func.isRequired,
  renderSuggestion: PropTypes.func.isRequired,
  suggestions: PropTypes.array.isRequired,
  suggestionProperty: PropTypes.string.isRequired,
  required: PropTypes.bool,
  noAbsoluteSuggestionContainer: PropTypes.bool
}

export default withStyles(Styles)(Autocomplete)



// WEBPACK FOOTER //
// ./src/common/auto-complete.js